// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1G7ld","footer":"ModalCreateQualiphyProcedure_footer__1HDS4","additionData":"ModalCreateQualiphyProcedure_additionData__24jHr"};